export const DEDUCTION_CONFIG = {
  behaviour_issue: {
    rude_behavior: 250,
    abusive_language: 500,
  },

  delivery_issue: {
    delay_delivery: 0,
    delivery_boy_issue: 0,
    rto_order_concern: 0,
    india_post: 0,
    online_order: 0,
    wants_future_delivery: 0,
  },

  wrong_product_delivered: {
    incorrect_product: 0,
    missing_product: 0,
    other_product_delivered: 0,
  },

  product_complaint: {
    medicine_not_effective: 0,
    product_quality_issue: 0,
    quantity_issue: 0,
    manufacturing_issue: 0,
  },

  payment_refund_request: {
    extra_payment_received: 0,
    refund_not_received: 0,
    payment_failed: 0,
  },

  need_to_talk: {},

  number_block_request: {
    back_to_back_calls: 0,
  },

  wrong_punch_or_info: {
    wrong_punch_miss_punch: 250,
    incomplete_incorrect_information: 250,
    price_issue: 250,
    fake_order_fake_commitment: 500,
    return_refund_issue: 500,
  },

  technical_glitch: {
    payment_done_but_order_missing: 0,
    after_delivery_free_medicine: 0,
  },

  other: {
    other: 0,
  },
};